<template>
  <button class="gradient-button">
    <slot />
  </button>
</template>
<script setup>
</script>
<style scoped>

.gradient-button {
  background: linear-gradient(135deg, #00d1b2 0%, #3273dc 100%);
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  position: relative;
  overflow: hidden;
}

.gradient-button:hover {
  transform: translateY(-2px) scale(1.02);
  box-shadow: 0 8px 25px rgba(0, 209, 178, 0.3);
  background: linear-gradient(135deg, #00e5c5 0%, #4285f4 100%);
}

.gradient-button:active {
  transform: translateY(0) scale(0.98);
  box-shadow: 0 4px 12px rgba(0, 209, 178, 0.2);
}
</style>
